import React from 'react';
import './Home.css';

const Home: React.FC = () => {
  return (
    <main>
      <div className="geometric-shape shape-1"></div>
      <div className="geometric-shape shape-2"></div>
      <div className="content">
        <h1>Coming Soon</h1>
        <p>The future of AI assistance is on its way.</p>
        <div className="buttons">
          <a 
            href="https://discord.gg/45MHwt5rBM" 
            className="button button-primary" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Join Discord
          </a>
          <a 
            href="https://github.com/AssistantsLab" 
            className="button button-secondary" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            GitHub
          </a>
        </div>
      </div>
    </main>
  );
};

export default Home;